import React, { FunctionComponent } from 'react'
import { useAllPermissions, useAnyPermissions } from '../../utils/hooks'

interface Props {
    condition?: boolean,
    permissions: string[],
}

export const HasAllPermissions: FunctionComponent<Props> = props => {
    const isPermit = useAllPermissions(props.permissions)

    return <>{(props.condition ?? true) && isPermit && props.children}</>
}

export const HasAnyPermission: FunctionComponent<Props> = props => {
    const isPermit = useAnyPermissions(props.permissions)

    return <>{(props.condition ?? true) && isPermit && props.children}</>
}